import React from "react";

import Container from "@mui/material/Container";
import { Grid } from "@mui/material";

import logo from "../../Images/logo.png";
import medium from "../../Images/medium.png";
import twitter from "../../Images/twitter.png";
import email from "../../Images/email.png";
import rayswaplogoanim from "../../Images/rslogogif.gif";

import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="Ray---Header">
      <Container>
        <Grid container paddingTop={3}>
          <Grid xs={12} sm={4}>
            <Link style={{ textDecoration: "none" }} to="/">
              <img className="img-fluid" alt="logo" src={logo} />
            </Link>
          </Grid>
          <Grid
            xs={12}
            sm={8}
            className="text-center text-sm-right d-none d-sm-inline-block"
          >
            <Link
              style={{ textDecoration: "none" }}
              href="#"
              className="Rey---Head---Button1 d-none d-sm-inline-block mt-3"
            >
              contact support
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              to="/swap"
              className="Rey---Head---Button px-5 py-3 ml-4"
            >
              Enter app
            </Link>
          </Grid>
        </Grid>
        <Grid container alignItems="center">
          <Grid xs={12} sm={6}>
            <div
              style={{ color: "white" }}
              className="Ray---Head--heading pt-5 mt-sm-5"
            >
              <h1>
                {" "}
                MAKE <span className="fancy">DEFINITE</span> GAINS!
              </h1>
              <p>
                RaySwap has been built from the ground up to support the up and
                coming REI network. Users can use RaySwap to swap GXS native
                tokens and add/remove liquidity from projects with further plans
                to add more features down the line.
                <br />
                <br />
                RaySwap is your guiding light to making successful trades on the
                REI network.
              </p>
            </div>

            <Link
              style={{ textDecoration: "none" }}
              to="/swap"
              className="Rey---Head---Button2 py-3 px-5 my-2 d-inline-block mr-3"
            >
              Enter app
            </Link>
            <Link
              style={{ textDecoration: "none" }}
              href="#"
              className="Rey---Head---Button3 py-3 px-5 my-2 d-inline-block"
            >
              Docs
            </Link>
            <div class="social-links">
              <a href="#">
                <i>
                  <img alt="" src={email} />
                </i>
              </a>
              <a href="#">
                <i>
                  <img alt="" src={twitter} />
                </i>
              </a>
              <a href="#">
                <i>
                  <img alt="" src={medium} />
                </i>
              </a>
            </div>
          </Grid>
          <Grid xs={12} sm={6}>
            <img
              src={rayswaplogoanim}
              alt=""
              className="img-fluid"
              autoPlay
              loop
              muted
              min-width="750"
              height="500"
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Header;
